import script from "./CreateTaskFromTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTaskFromTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CreateTaskFromTemplate.vue?vue&type=style&index=0&id=22c67237&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c67237"]])

export default __exports__